import Swal from "sweetalert2";

export const alertValidation = (text, fn) => {
    Swal.fire({
        text: text,
        icon: 'warning',
        confirmButtonText: '확인',
    }).then(r => { if (r.isConfirmed)  fn(); });
}